export function hasHindiCharacters(str) {
  return str.split('').filter( function(char){ 
    var charCode = char.charCodeAt(); return charCode >= 2309 && charCode <=2361;
  }).length > 0;
}

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}


export function insertAtIndex(arr, index, newItem) {
  return [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    ...newItem,
    // part of the array after the specified index
    ...arr.slice(index)
  ];
}

export function validateEmail (email) {
  var emailRegx = /\b(?:(?![_.-])(?!.*[_.-]{2})[a-z0-9_.-]+(?<![_.-]))@(?:(?!-)(?!.*--)[a-z0-9-]+(?<!-)\.)*meesho\.com\b/i;
  if (emailRegx.test(email)) {
    return (email.indexOf('@meesho.com', email.length - '@meesho.com'.length) !== -1);
  } else {
    return false;
  }
}

export const hasXss = (str = '') => {
  const sanitizedStr = str.toLowerCase().replace(/ /g, '');
  return ['<script>', '</script>', 'javascript:'].some((i) =>
    sanitizedStr.includes(i)
  );
};

export const containsNonEnglishCharacters = (text) => {
  // This regex checks if the entire string consists of only non-English characters,
  // numbers, and special characters
  const onlyNonEnglishRegex = /^[^a-zA-Z]*$/;
  return onlyNonEnglishRegex.test(text);
};

export const bytesToKB = (bytes) => {
  return bytes ? (bytes / 1024) : 0;
};

export const kbToBytes = (kb) => {
  return kb ? (kb * 1024) : 0;
};

export const getRedirectPath = (currentPathname) => {
  const urlParams = new URLSearchParams(window.location.search);
  const existingRedirect = urlParams.get('redirect');
  return existingRedirect 
    ? existingRedirect 
    : (currentPathname === '/login' ? '/' : currentPathname);
};